export default "/6295673e97fffb085c1e3edd3bdb6d76.jpg";